export default __webpack_public_path__ + "static/media/hiw-slide-5a.605f13ce.png";